import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6c8d6741&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "@/sass/06_atoms/link.scss?vue&type=style&index=0&id=6c8d6741&scoped=true&lang=scss&"
import style1 from "@/sass/08_modules/project-list.scss?vue&type=style&index=1&id=6c8d6741&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d6741",
  null
  
)

export default component.exports